import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useState } from 'react';
import { useHistory } from 'react-router';
import { useIsMounted, useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
const HTTP_CONFLICT = 409;
export const useAgreementTriage = (param)=>{
    let { extraction: extractionFromProps, conversationId, testIds } = param;
    const [extraction, setExtraction] = useState(()=>extractionFromProps.clone());
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { api } = useStoreActions();
    const { showErrorToast } = useOverlayContext();
    const { t } = useLocaleKeys();
    const history = useHistory();
    const isMounted = useIsMounted();
    const submitCreate = async ()=>{
        setIsSubmitting(true);
        const result = await handleRequest(api.agreementImport.create({
            conversationId,
            extraction
        }));
        if (!isMounted()) return;
        if (result.success) {
            history.replace(_object_spread_props(_object_spread({}, history.location), {
                state: {}
            }));
            history.push(routes.draft(result.data.draftId));
        } else {
            const isConflict = result.error instanceof ErrorResponse && result.error.hasStatus([
                HTTP_CONFLICT
            ]);
            if (isConflict) {
                showErrorToast(t.agreementImport.triageModal.submitConflictError(), testIds.SubmitErrorToast());
            } else {
                showErrorToast(t.agreementImport.triageModal.submitError(), testIds.SubmitErrorToast());
            }
            setIsSubmitting(false);
        }
    };
    return {
        extraction,
        setExtraction,
        isSubmitting,
        submitCreate
    };
};
